/* Mats · Modelo chico / chica en la galería de la ficha (complemento de assets/mats-product.js; se carga en theme.liquid)
   Las fotos de modelo se reconocen por su texto alternativo: «… · modelo chico» / «… · modelo chica». Los planos se ven siempre.
   Qué modelo se muestra (de más a menos prioridad):
     1. ?modelo=chico | chica | ambos en la URL
     2. la colección de la URL (/collections/men/products/… → chico; womens o boxy-t-shirt → chica; otra → ambos)
     3. la última zona visitada (sessionStorage «mats:modelo», la pone theme.liquid:
        colección Hombre y portada → chico; colección Mujer, Boxy y página Mujer → chica; resto de colecciones → ambos)
   Si el producto no tiene fotos de ese modelo (p. ej. una boxy en la zona de chico) se ven todas. */
(() => {
  const KEY = 'mats:modelo';
  const valid = (g) => g === 'chico' || g === 'chica' || g === 'ambos';
  const BY_COLLECTION = { men: 'chico', womens: 'chica', 'boxy-t-shirt': 'chica' };

  function genderCtx() {
    try {
      const q = new URLSearchParams(location.search).get('modelo');
      if (valid(q)) return q;
    } catch (e) { /* noop */ }
    const m = location.pathname.match(/\/collections\/([^/]+)\/products\//);
    if (m) return BY_COLLECTION[m[1]] || 'ambos';
    try {
      const s = sessionStorage.getItem(KEY);
      if (valid(s)) return s;
    } catch (e) { /* noop */ }
    return 'ambos';
  }

  function modeloDe(li) {
    if (li.dataset.modelo !== undefined) return li.dataset.modelo;
    const img = li.querySelector('img');
    const alt = ((img && img.getAttribute('alt')) || '').toLowerCase();
    li.dataset.modelo = alt.includes('modelo chica') ? 'chica' : alt.includes('modelo chico') ? 'chico' : '';
    return li.dataset.modelo;
  }

  function applyModelo(el) {
    const items = el.mediaItems || [];
    if (!items.length) return;
    const g = genderCtx();
    if (g === 'ambos') return;
    if (!items.some((li) => modeloDe(li) === g)) return;
    let changed = false;
    items.forEach((li) => {
      const mo = modeloDe(li);
      if (mo && mo !== g && !li.hidden) { li.hidden = true; changed = true; }
    });
    if (!changed) return;
    // Recolocar destacada, impares y contador (igual que applyGallery)
    items.forEach((li) => li.classList.remove('is-feature', 'is-solo', 'is-wide'));
    const visible = el.visibleMedia();
    if (visible[0]) visible[0].classList.add('is-feature');
    if (visible.length === 1) visible[0].classList.add('is-solo');
    const featureWide = el.classList.contains('mb-pd--feature') && visible.length > 1;
    const inGrid = featureWide ? visible.length - 1 : visible.length;
    if (visible.length > 1 && inGrid % 2 === 1) visible[visible.length - 1].classList.add('is-wide');
    if (el.total) el.total.textContent = visible.length;
  }

  customElements.whenDefined('mats-product').then(() => {
    const C = customElements.get('mats-product');
    if (!C || C.prototype._matsModelo) return;
    C.prototype._matsModelo = true;
    const orig = C.prototype.applyGallery;
    C.prototype.applyGallery = function () {
      orig.apply(this, arguments);
      applyModelo(this);
    };
    // Fichas que ya se pintaron antes de cargar este archivo
    document.querySelectorAll('mats-product').forEach((el) => { if (el.mediaItems) el.applyGallery(); });
  });
})();

/* Mats · Fondo de las fotos de camiseta (17 oct 2026)
   Las fotos nuevas tienen su propio gris (más oscuro y con degradado en las de modelo) y no coincide con el --mats-media (#d9d9d9).
   Cuando el hueco no es 3:4 (tarjetas cuadradas, última foto «ancha» de la ficha) se veía una franja más clara.
   Aquí se copian los bordes izquierdo y derecho de cada foto en una imagen diminuta (2 × 32 px) que se estira como fondo:
   las franjas laterales continúan el fondo real de la foto, con su degradado.
   Solo en camisetas: tarjetas marcadas con data-mats-bg (snippet mats-product-card; las sudaderas no lo llevan) y, en la ficha,
   las fotos del catálogo nuevo (texto alternativo «… · plano · …» / «… · modelo chico|chica · …»). Las sudaderas siguen con #d9d9d9. */
(() => {
  const SEL = '.mats-card[data-mats-bg] .mats-card__img--primary, .mb-pd__media-item img';
  const NEW_ALT = / · (plano|modelo chic[oa]) · /i;
  const H = 32, MID = 256;
  let a, b, ca, cb;
  try {
    a = document.createElement('canvas'); a.width = 2; a.height = MID; ca = a.getContext('2d');
    b = document.createElement('canvas'); b.width = 2; b.height = H; cb = b.getContext('2d');
  } catch (e) { return; }
  if (!ca || !cb) return;
  ca.imageSmoothingQuality = 'high'; cb.imageSmoothingQuality = 'high';

  function paint(img) {
    if (!img || img.dataset.matsBg || !img.complete || !img.naturalWidth || !img.matches(SEL)) return;
    if (!img.closest('.mats-card') && !NEW_ALT.test(img.getAttribute('alt') || '')) return;
    img.dataset.matsBg = '1';
    const w = img.naturalWidth, h = img.naturalHeight, sw = Math.max(1, Math.round(w * 0.015));
    let url;
    try {
      ca.clearRect(0, 0, 2, MID); cb.clearRect(0, 0, 2, H);
      ca.drawImage(img, 0, 0, sw, h, 0, 0, 1, MID);
      ca.drawImage(img, w - sw, 0, sw, h, 1, 0, 1, MID);
      cb.drawImage(a, 0, 0, 2, MID, 0, 0, 2, H);
      url = b.toDataURL('image/png');
    } catch (e) { return; }
    const bg = `url("${url}") 0 0 / 100% 100% no-repeat`;
    const card = img.closest('.mats-card');
    if (card) { card.style.setProperty('--mcard-media', bg); return; }
    const li = img.closest('.mb-pd__media-item');
    if (li) li.style.background = bg;
  }

  document.addEventListener('load', (e) => { if (e.target && e.target.tagName === 'IMG') paint(e.target); }, true);
  const scan = () => document.querySelectorAll(SEL).forEach(paint);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
